import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../core/models/generic-models';
import { IForgotPasscodeRequest, IForgotPasscodeResponse } from '../models/forgot-passcode.model';

export const loadForgotPasswordsUserNeedsHelpRequest = createAction(
  '[ForgotPasscode] Load ForgotPasscode',
  props<{ request: IForgotPasscodeRequest }>()
);

export const loadForgotPasswordsUserNeedsHelpSuccess = createAction(
  '[ForgotPasscode] Load ForgotPasscode Success',
  props<{ response: IForgotPasscodeResponse }>()
);

export const loadForgotPasswordsUserNeedsHelpFailure = createAction(
  '[ForgotPasscode] Load ForgotPasscode Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);

export const clearForgotPasswordsUserNeedsHelpFailure = createAction('[ForgotPasscode] Clear ForgotPasscode Failure');
